<div class="card-body p-0">

    <!-- MATRIMONIAL LISTING -->
    <div *ngIf="viewMode === 'list'">

        <div class="rana-mat-page-header">
            <div>
                <div class="rana-mat-eyebrow">Matrimonial Services</div>
                <h1 class="rana-mat-title">Find Your Life Partner</h1>
                <p class="rana-mat-subtitle">Profiles submitted and reviewed within the RANA community.</p>
            </div>
            <button type="button" class="rana-mat-btn-primary" (click)="openCreateForm()">
                <i class="uil uil-user-plus"></i> Add Profile
            </button>
        </div>

        <div class="rana-mat-divider-accent"></div>

        <!-- SEARCH -->
        <div class="rana-mat-search-bar">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#7A6F63" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg>
            <label for="matSearch" class="sr-only">Search profiles</label>
            <input id="matSearch" type="text" [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}"
                   (ngModelChange)="applyFilter()"
                   placeholder="Search by name, profession, or city">
        </div>

        <div *ngIf="loading" class="rana-mat-empty">Loading profiles...</div>
        <div *ngIf="!loading && filteredProfiles.length === 0" class="rana-mat-empty">No profiles available.</div>

        <div class="row" *ngIf="!loading && filteredProfiles.length > 0">
            <div *ngFor="let profile of filteredProfiles | paginate: { itemsPerPage: 3, currentPage: page }" class="col-md-4 mb-4">
                <div class="rana-mat-card" (click)="viewProfile(profile)">

                    <div class="rana-mat-card-photo">
                        <img [src]="profile.imageUrl" (error)="onImageError($event)" alt="Profile Photo">
                        <span class="rana-mat-badge-pending" *ngIf="profile.status === 'PENDING'">Pending Approval</span>
                        <div class="rana-mat-card-scrim">
                            <div class="rana-mat-card-name">{{ profile.firstName }} {{ profile.lastName }}</div>
                            <div class="rana-mat-card-age">{{ getAge(profile.dob) }} yrs</div>
                        </div>
                    </div>

                    <div class="rana-mat-card-info">
                        <div class="rana-mat-card-meta">
                            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#B99A55" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="13" rx="2"></rect><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                            <span>{{ profile.profession || 'N/A' }}</span>
                            <span class="rana-mat-dot">&middot;</span>
                            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#B99A55" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6.6 7-11.5A7 7 0 0 0 5 9.5C5 14.4 12 21 12 21z"></path><circle cx="12" cy="9.5" r="2.3"></circle></svg>
                            <span>{{ profile.city || 'N/A' }}{{ profile.city && profile.state ? ', ' + profile.state : '' }}</span>
                        </div>
                        <div class="rana-mat-card-posted">Posted by {{ profile.createdByName || 'Member' }}</div>
                    </div>

                    <div class="rana-mat-card-footer">
                        <a href="javascript:void(0)" class="rana-mat-view-link" (click)="$event.stopPropagation(); viewProfile(profile)">
                            View Profile
                            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="m13 6 6 6-6 6"></path></svg>
                        </a>
                        <div class="rana-mat-card-actions" *ngIf="profile.createdBy === userId" (click)="$event.stopPropagation()">
                            <button type="button" class="rana-mat-icon-btn" title="Edit" (click)="openEditForm(profile)">
                                <i class="uil uil-edit"></i>
                            </button>
                            <button type="button" class="rana-mat-icon-btn danger" title="Delete" (click)="deleteProfile(profile.profileId)">
                                <i class="uil uil-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <pagination-controls *ngIf="filteredProfiles && filteredProfiles.length > 3" (pageChange)="page = $event"></pagination-controls>
    </div>

    <!-- CREATE/EDIT FORM -->
    <div *ngIf="viewMode === 'form'" class="rana-mat-panel">

        <div class="rana-mat-panel-header">
            <div class="rana-mat-avatar">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"></path></svg>
            </div>
            <div class="rana-mat-panel-header-text">
                <h1 class="rana-mat-panel-title">{{ isEditing ? 'Edit Profile' : 'Add Profile' }}</h1>
                <div class="rana-mat-panel-subtitle">{{ isEditing ? 'Update the matrimonial profile details.' : 'Share a profile with the RANA community.' }}</div>
            </div>
        </div>

        <div class="rana-mat-panel-divider"></div>

        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
            <div class="rana-mat-panel-content">

                <div class="rana-mat-form-section-label">Photo</div>
                <div class="rana-mat-photo-row">
                    <div class="rana-mat-photo-preview">
                        <img *ngIf="uploadedImageUrl" [src]="uploadedImageUrl" alt="Profile Photo">
                        <svg *ngIf="!uploadedImageUrl" viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"></circle><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8"></path></svg>
                    </div>
                    <div class="form-group mb-0 flex-grow-1">
                        <input type="file" class="form-control" (change)="onFileSelect($event, profileForm.get('profileId')?.value)">
                    </div>
                </div>

                <div class="rana-mat-form-section-label">Basic Details</div>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label>First Name</label>
                        <input type="text" formControlName="firstName" class="form-style big with-border form-style-with-icon" autocomplete="off">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Last Name</label>
                        <input type="text" formControlName="lastName" class="form-style big with-border form-style-with-icon" autocomplete="off">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Gender</label>
                        <select formControlName="gender" class="form-style big with-border form-style-with-icon">
                            <option value="">-- Select Gender --</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Date of Birth</label>
                        <input type="date" formControlName="dob" class="form-style big with-border form-style-with-icon">
                        <div *ngIf="profileForm.get('dob')?.errors?.['ageTooLow'] && profileForm.get('dob')?.touched" class="text-danger size-12 mt-1">
                            Age must be at least {{ profileForm.get('dob')?.errors?.['ageTooLow'].requiredAge }}.
                            Current age: {{ profileForm.get('dob')?.errors?.['ageTooLow'].actualAge }}
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Education</label>
                        <input type="text" formControlName="education" class="form-style big with-border form-style-with-icon">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Profession</label>
                        <input type="text" formControlName="profession" class="form-style big with-border form-style-with-icon">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Height</label>
                        <input type="text" formControlName="height" class="form-style big with-border form-style-with-icon">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Gotra</label>
                        <input type="text" formControlName="gotra" class="form-style big with-border form-style-with-icon">
                    </div>
                </div>

                <div class="rana-mat-form-section-label">Location</div>
                <div class="row">
                    <div class="col-md-4 mb-3">
                        <input type="text" formControlName="city" placeholder="City" class="form-style big with-border form-style-with-icon">
                    </div>
                    <div class="col-md-4 mb-3">
                        <input type="text" formControlName="state" placeholder="State" class="form-style big with-border form-style-with-icon">
                    </div>
                    <div class="col-md-4 mb-3">
                        <input type="text" formControlName="country" placeholder="Country" class="form-style big with-border form-style-with-icon">
                    </div>
                </div>

                <div class="rana-mat-form-section-label">Contact</div>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label>Email</label>
                        <input type="email" formControlName="email" class="form-style big with-border form-style-with-icon">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label>Phone</label>
                        <input type="text" formControlName="phone" class="form-style big with-border form-style-with-icon">
                    </div>
                </div>

                <div class="rana-mat-form-section-label">About &amp; Expectations</div>
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <label>About Me</label>
                        <app-rt-editor formControlName="aboutMe" [(ngModel)]="mAboutMe" name="aboutMe"></app-rt-editor>
                    </div>
                    <div class="col-md-12 mb-3">
                        <label>Expectations</label>
                        <app-rt-editor formControlName="expectations" [(ngModel)]="mExpectations" name="expectations"></app-rt-editor>
                    </div>
                </div>

                <div class="rana-mat-ack-box">
                    <input type="checkbox" id="matAcknowledgeCheck" formControlName="acknowledge" class="rana-mat-ack-checkbox">
                    <label for="matAcknowledgeCheck" class="rana-mat-ack-label">
                        I acknowledge that the information provided by me is true and correct.
                        I am solely responsible for the information submitted in this profile.
                        RANA is not responsible for the accuracy or authenticity of this content.
                    </label>
                </div>
                <div class="text-danger mt-1" *ngIf="profileForm.get('acknowledge')?.invalid && profileForm.get('acknowledge')?.touched">
                    You must agree to the acknowledgement before submitting.
                </div>
            </div>

            <div class="rana-mat-panel-actions">
                <button type="button" class="rana-mat-btn-ghost" (click)="resetForm(); backToList();">
                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"></path><path d="m11 18-6-6 6-6"></path></svg>
                    Back to Listing
                </button>
                <button type="submit" class="rana-mat-btn-primary">
                    {{ isEditing ? 'Update Profile' : 'Create Profile' }}
                </button>
            </div>
        </form>
    </div>


    <!-- DETAIL VIEW -->
    <div *ngIf="viewMode === 'detail' && selectedProfile" class="rana-mat-panel">
        <div class="rana-mat-detail-body">

            <!-- LEFT: PHOTO + FACTS -->
            <div class="rana-mat-detail-photo-col">

                <div class="rana-mat-photo-frame">
                    <img [src]="imageUrl" alt="Profile Photo">
                </div>

                <div class="rana-mat-posted-by">Posted by {{ selectedProfile.createdByName || 'Member' }}</div>

                <div class="rana-mat-stat-grid">
                    <div class="rana-mat-stat-card">
                        <div class="rana-mat-stat-label">Age</div>
                        <div class="rana-mat-stat-value">{{ getAge(selectedProfile.dob) }}</div>
                    </div>
                    <div class="rana-mat-stat-card">
                        <div class="rana-mat-stat-label">Height</div>
                        <div class="rana-mat-stat-value">{{ selectedProfile.height || 'N/A' }}</div>
                    </div>
                    <div class="rana-mat-stat-card">
                        <div class="rana-mat-stat-label">Gotra</div>
                        <div class="rana-mat-stat-value">{{ selectedProfile.gotra || 'N/A' }}</div>
                    </div>
                    <div class="rana-mat-stat-card">
                        <div class="rana-mat-stat-label">Education</div>
                        <div class="rana-mat-stat-value">{{ selectedProfile.education || 'N/A' }}</div>
                    </div>
                </div>

                <div class="rana-mat-detail-actions-col">
                    <button type="button" class="rana-mat-btn-primary block"
                            (click)="approveProfile(selectedProfile.profileId || '')"
                            *ngIf="(userRole?.MATRIMONIAL?.includes('APPROVE')) && selectedProfile.status === 'PENDING'">
                        Approve Profile
                    </button>
                    <button type="button" class="rana-mat-btn-ghost block" (click)="backToList()">Back to Listings</button>
                </div>
            </div>

            <!-- RIGHT: DETAILS -->
            <div class="rana-mat-detail-info-col">

                <h1 class="rana-mat-detail-name">{{ selectedProfile.firstName }} {{ selectedProfile.lastName }}</h1>

                <div class="rana-mat-pill-row">
                    <span class="rana-mat-pill">{{ getAge(selectedProfile.dob) }} years</span>
                    <span class="rana-mat-pill" *ngIf="selectedProfile.profession">{{ selectedProfile.profession }}</span>
                    <span class="rana-mat-pill" *ngIf="selectedProfile.city">{{ selectedProfile.city }}{{ selectedProfile.state ? ', ' + selectedProfile.state : '' }}</span>
                    <span class="rana-mat-pill success" *ngIf="selectedProfile.status === 'APPROVED'">Approved</span>
                    <span class="rana-mat-pill pending" *ngIf="selectedProfile.status === 'PENDING'">Pending Approval</span>
                </div>

                <div class="rana-mat-panel-divider standalone"></div>

                <ng-container *ngIf="selectedProfile.aboutMe">
                    <div class="rana-mat-form-section-label">About</div>
                    <div class="rana-mat-rich-text">
                        <app-rt-editor [disabled]="true" [ngModel]="selectedProfile.aboutMe"></app-rt-editor>
                    </div>
                </ng-container>

                <ng-container *ngIf="selectedProfile.expectations">
                    <div class="rana-mat-form-section-label mt-4">Expectations</div>
                    <div class="rana-mat-rich-text">
                        <app-rt-editor [disabled]="true" [ngModel]="selectedProfile.expectations"></app-rt-editor>
                    </div>
                </ng-container>

                <div class="rana-mat-form-section-label mt-4">Details</div>
                <div class="rana-mat-info-grid">
                    <div class="rana-mat-info-card">
                        <div class="rana-mat-info-icon">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 9 12 4 2 9l10 5 10-5z"></path><path d="M6 11v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5"></path></svg>
                        </div>
                        <div class="min-width-0">
                            <div class="rana-mat-info-label">Education</div>
                            <div class="rana-mat-info-value">{{ selectedProfile.education || 'N/A' }}</div>
                        </div>
                    </div>
                    <div class="rana-mat-info-card">
                        <div class="rana-mat-info-icon">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="13" rx="2"></rect><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                        </div>
                        <div class="min-width-0">
                            <div class="rana-mat-info-label">Profession</div>
                            <div class="rana-mat-info-value">{{ selectedProfile.profession || 'N/A' }}</div>
                        </div>
                    </div>
                    <div class="rana-mat-info-card">
                        <div class="rana-mat-info-icon">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6.6 7-11.5A7 7 0 0 0 5 9.5C5 14.4 12 21 12 21z"></path><circle cx="12" cy="9.5" r="2.3"></circle></svg>
                        </div>
                        <div class="min-width-0">
                            <div class="rana-mat-info-label">Location</div>
                            <div class="rana-mat-info-value">{{ selectedProfile.city }}{{ selectedProfile.state ? ', ' + selectedProfile.state : '' }}{{ selectedProfile.country ? ', ' + selectedProfile.country : '' }}</div>
                        </div>
                    </div>
                    <div class="rana-mat-info-card">
                        <div class="rana-mat-info-icon">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="m3 7 9 6 9-6"></path></svg>
                        </div>
                        <div class="min-width-0">
                            <div class="rana-mat-info-label">Email</div>
                            <div class="rana-mat-info-value">{{ selectedProfile.email || 'N/A' }}</div>
                        </div>
                    </div>
                    <div class="rana-mat-info-card">
                        <div class="rana-mat-info-icon">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.7a2 2 0 0 1-.4 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.5 2.7.6a2 2 0 0 1 1.7 2z"></path></svg>
                        </div>
                        <div class="min-width-0">
                            <div class="rana-mat-info-label">Phone</div>
                            <div class="rana-mat-info-value">{{ selectedProfile.phone || 'N/A' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
